module.exports = __webpack_public_path__ + "assets/images/android_ride_this-4a087aaa987c0abda97dcf6997930cc9.mp4";